<template>
    <transition name="fade">
        <div class="info-box">
            <mdicon name="information-outline" class="text-primary mr-4" size="24"></mdicon>
            <p class="text-dark" style="font-size: 15px;">{{ message }}
            </p>
        </div>
    </transition>
</template>
<script>
export default {
    props: {
        message: String,
    }

}
</script>
<style lang="">

</style>
